import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

interface Input {
    projectId: string;
    updateId: string;
}

interface Options {
    onSuccess?: () => void;
}

export function useDeleteProjectUpdateMutation(options?: Options) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (input: Input) => {
            const res = await apiClient.deleteProjectUpdate({
                params: {
                    projectId: input.projectId,
                    updateId: input.updateId,
                },
            });
            if (res.status !== 200) {
                throw new Error("Error deleting project update");
            }
            return res.body;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["project"] });
            options?.onSuccess?.();
        },
    });
}
